import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components/macro';

import { baseSpacing, colors } from 'css/constants';

const DashboardPrimitive = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.offWhite};
`;

const DashboardBodyPrimitive = styled.div`
  position: relative;
  flex-grow: 1;
  overflow: auto;

  & > div {
    padding: ${baseSpacing}px;
  }
`;

const DashboardHeaderPrimitive = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: ${baseSpacing / 2}px ${baseSpacing}px;
  background-color: #fff;

  h1 {
    margin: 0;
  }
`;

export const DashboardHeader = ({ children }) => (
  <DashboardHeaderPrimitive>
    {React.Children.toArray(children)}
  </DashboardHeaderPrimitive>
);

DashboardHeader.propTypes = {
  children: node.isRequired
};

export const DashboardBody = ({ children, className }) => (
  <DashboardBodyPrimitive className={className}>
    <div>{React.Children.toArray(children)}</div>
  </DashboardBodyPrimitive>
);

DashboardBody.propTypes = {
  children: node.isRequired,
  className: string
};

const Dashboard = ({ children }) => (
  <DashboardPrimitive>{React.Children.toArray(children)}</DashboardPrimitive>
);

Dashboard.propTypes = {
  children: node.isRequired
};

export default Dashboard;
